module.exports = __webpack_public_path__ + "static/shop-861589c6deb9b18dcd5b8eac961cf082.png";